import React, { Component } from 'react';

class Modal extends Component {
  noPropagation(e) {
    e.stopPropagation();
  }
  render() {
    let display = this.props.show ? 'flex' : 'none';
    return (
      <div
        onClick={this.props.close}
        className={`modal-holder ${this.props.className}`}
        style={{ display: display }}
      >
        <div
          id={`${this.props.modalId ? this.props.modalId : ''}`}
          className="modal"
          style={{ display: display }}
        >
          <div className="modal-body" onClick={this.noPropagation}>
            {!this.props.hideCloseButton && (
              <div onClick={this.props.close} className="close-button">
                &times;
              </div>
            )}
            {this.props.children}
          </div>
        </div>
      </div>
    );
  }
}

export default Modal;
